import "./privacyPolicy.scss";
import React, { useEffect } from 'react';
import { useTranslation } from "react-i18next";
import OrderHeadSectionComponent from "../../../components/headSection/components/OrderHeadSectionComponent";
import ProfilePath from "../../../sections/profileSection/components/ProfilePath";
import ContactSectionComponent from "../../main/sections/contactSection/ContactSectionComponent";

const PrivacyPolicy = () => {
	const { t } = useTranslation();
	
	useEffect(() => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	}, []);
	
	return (
		<div className="privacyPolicyComponent__container">
			<div className="privacyPolicyComponent__container-content-overlay"></div>
			<OrderHeadSectionComponent />
			<div className="privacyPolicyComponent__container-content">
				<div className="legals">
					<h2 className="legals__title">{t('main.privacyPolicy')}</h2>
					<div className="legals__text-block">
						<p className="legals__text">{t('legal.lastUpdated')}</p>
					</div>
					<div className="legals__text-block">
						<p className="legals__text">{t('legal.privacyPolicy1')}</p>
					</div>
					<div className="legals__text-block">
						<p className="legals__text">{t('legal.privacyPolicy2')}</p>
					</div>
					<div className="legals__text-block">
						<p className="legals__text legals__subtitle">{t('legal.privacyPolicy3')}</p>
					</div>
					<div className="legals__text-block">
						<p className="legals__text legals__subtitle">{t('legal.privacyPolicy4')}</p>
						<p className="legals__text">{t('legal.privacyPolicy5')}</p>
					</div>
					<div className="legals__text-block">
						<p className="legals__text legals__subtitle">{t('legal.privacyPolicy6')}</p>
						<p className="legals__text">{t('legal.privacyPolicy7')}</p>
						<p className="legals__text">
							<span className="legals__text legals__subtitle">{t('legal.privacyPolicy8')}</span> {t('legal.privacyPolicy9')}
						</p>
						<p className="legals__text">
							<span className="legals__text legals__subtitle">{t('legal.privacyPolicy10')}</span> {t('legal.privacyPolicy11')}
						</p>
						<p className="legals__text">
							<span className="legals__text legals__subtitle">{t('legal.privacyPolicy12')}</span> {t('legal.privacyPolicy13')}
						</p>
						<p className="legals__text">
							<span className="legals__text legals__subtitle">{t('legal.privacyPolicy14')}</span> {t('legal.privacyPolicy15')}
						</p>
						<p className="legals__text">
							<span className="legals__text legals__subtitle">{t('legal.privacyPolicy16')}</span> {t('legal.privacyPolicy17')}
						</p>
						<p className="legals__text">
							<span className="legals__text legals__subtitle">{t('legal.privacyPolicy18')}</span> {t('legal.privacyPolicy19')}
						</p>
						<p className="legals__text">
							<span className="legals__text legals__subtitle">{t('legal.privacyPolicy20')}</span> {t('legal.privacyPolicy21')}
						</p>
						<p className="legals__text">
							<span className="legals__text legals__subtitle">{t('legal.privacyPolicy22')}</span> {t('legal.privacyPolicy23')}
						</p>
						<p className="legals__text">
							<span className="legals__text legals__subtitle">{t('legal.privacyPolicy24')}</span> {t('legal.privacyPolicy25')}
						</p>
						<p className="legals__text">
							<span className="legals__text legals__subtitle">{t('legal.privacyPolicy26')}</span> {t('legal.privacyPolicy27')}
						</p>
						<p className="legals__text">
							<span className="legals__text legals__subtitle">{t('legal.privacyPolicy28')}</span> {t('legal.privacyPolicy29')}
						</p>
						<p className="legals__text">
							<span className="legals__text legals__subtitle">{t('legal.privacyPolicy30')}</span> {t('legal.privacyPolicy31')}{' '}
							<a className="link" href="/">
								https://wondr.es
							</a>
						</p>
						<p className="legals__text">
							<span className="legals__text legals__subtitle">{t('legal.privacyPolicy32')}</span> {t('legal.privacyPolicy33')}
						</p>
					</div>
					<div className="legals__text-block">
						<p className="legals__text legals__subtitle">{t('legal.privacyPolicy34')}</p>
					</div>
					<div className="legals__text-block">
						<p className="legals__text legals__subtitle">{t('legal.privacyPolicy35')}</p>
					</div>
					<div className="legals__text-block">
						<p className="legals__text legals__subtitle">{t('legal.privacyPolicy138')}</p>
						<p className="legals__text">{t('legal.privacyPolicy36')}</p>
						<ul>
							<li>
								<p className="legals__text">{t('legal.privacyPolicy37')}</p>
							</li>
							<li>
								<p className="legals__text">{t('legal.privacyPolicy38')}</p>
							</li>
							<li>
								<p className="legals__text">{t('legal.privacyPolicy39')}</p>
							</li>
							<li>
								<p className="legals__text">{t('legal.privacyPolicy40')}</p>
							</li>
							<li>
								<p className="legals__text">{t('legal.privacyPolicy139')}</p>
							</li>
						</ul>
					</div>
					<div className="legals__text-block">
						<p className="legals__text legals__subtitle">{t('legal.privacyPolicy139')}</p>
						<p className="legals__text">{t('legal.privacyPolicy41')}</p>
						<p className="legals__text">{t('legal.privacyPolicy42')}</p>
						<p className="legals__text">{t('legal.privacyPolicy43')}</p>
						<p className="legals__text">{t('legal.privacyPolicy44')}</p>
					</div>
					<div className="legals__text-block">
						<p className="legals__text legals__subtitle">{t('legal.privacyPolicy45')}</p>
						<p className="legals__text">{t('legal.privacyPolicy46')}</p>
						<ul>
							<li>
								<p className="legals__text">Google</p>
							</li>
							<li>
								<p className="legals__text">Apple</p>
							</li>
						</ul>
						<p className="legals__text">{t('legal.privacyPolicy47')}</p>
						<p className="legals__text">{t('legal.privacyPolicy48')}</p>
					</div>
					<div className="legals__text-block">
						<p className="legals__text legals__subtitle">{t('legal.privacyPolicy49')}</p>
						<p className="legals__text">{t('legal.privacyPolicy50')}</p>
						<p className="legals__text">
							<span className="legals__text legals__subtitle">{t('legal.privacyPolicy51')}</span> {t('legal.privacyPolicy52')}
						</p>
						<p className="legals__text">
							<span className="legals__text legals__subtitle">{t('legal.privacyPolicy53')}</span> {t('legal.privacyPolicy54')}
						</p>
					</div>
					<div className="legals__text-block">
						<p className="legals__text">{t('legal.privacyPolicy55')}</p>
						<p className="legals__text">{t('legal.privacyPolicy137')}</p>
					</div>
					<div className="legals__text-block">
						<p className="legals__text legals__subtitle">{t('legal.privacyPolicy56')}</p>
						<p className="legals__text">{t('legal.privacyPolicy57')}</p>
						<p className="legals__text">{t('legal.privacyPolicy58')}</p>
						<p className="legals__text">{t('legal.privacyPolicy59')}</p>
					</div>
					<div className="legals__text-block">
						<p className="legals__text legals__subtitle">{t('legal.privacyPolicy60')}</p>
						<p className="legals__text">{t('legal.privacyPolicy61')}</p>
						<p className="legals__text">{t('legal.privacyPolicy58')}</p>
						<p className="legals__text">{t('legal.privacyPolicy62')}</p>
					</div>
					<div className="legals__text-block">
						<p className="legals__text legals__subtitle">{t('legal.privacyPolicy63')}</p>
						<p className="legals__text">{t('legal.privacyPolicy61')}</p>
						<p className="legals__text">{t('legal.privacyPolicy58')}</p>
						<p className="legals__text">{t('legal.privacyPolicy64')}</p>
					</div>
					<div className="legals__text-block">
						<p className="legals__text">{t('legal.privacyPolicy66')}</p>
					</div>
					<div className="legals__text-block">
						<p className="legals__text legals__subtitle">{t('legal.privacyPolicy67')}</p>
						<p className="legals__text">{t('legal.privacyPolicy68')}</p>
						<p className="legals__text">
							<span className="legals__text legals__subtitle">{t('legal.privacyPolicy69')}</span> {t('legal.privacyPolicy70')}
						</p>
						<p className="legals__text">
							<span className="legals__text legals__subtitle">{t('legal.privacyPolicy71')}</span> {t('legal.privacyPolicy72')}
						</p>
						<p className="legals__text">
							<span className="legals__text legals__subtitle">{t('legal.privacyPolicy73')}</span> {t('legal.privacyPolicy74')}
						</p>
						<p className="legals__text">
							<span className="legals__text legals__subtitle">{t('legal.privacyPolicy75')}</span> {t('legal.privacyPolicy76')}
						</p>
						<p className="legals__text">
							<span className="legals__text legals__subtitle">{t('legal.privacyPolicy77')}</span> {t('legal.privacyPolicy78')}
						</p>
						<p className="legals__text">
							<span className="legals__text legals__subtitle">{t('legal.privacyPolicy79')}</span> {t('legal.privacyPolicy80')}
						</p>
						<p className="legals__text">
							<span className="legals__text legals__subtitle">{t('legal.privacyPolicy81')}</span> {t('legal.privacyPolicy82')}
						</p>
						<p className="legals__text">
							<span className="legals__text legals__subtitle">{t('legal.privacyPolicy83')}</span> {t('legal.privacyPolicy84')}
						</p>
					</div>
					<div className="legals__text-block">
						<p className="legals__text">{t('legal.privacyPolicy85')}</p>
						<p className="legals__text">
							<span className="legals__text legals__subtitle">{t('legal.privacyPolicy86')}</span> {t('legal.privacyPolicy87')}
						</p>
						<p className="legals__text">
							<span className="legals__text legals__subtitle">{t('legal.privacyPolicy81')}</span> {t('legal.privacyPolicy88')}
						</p>
						<p className="legals__text">
							<span className="legals__text legals__subtitle">{t('legal.privacyPolicy89')}</span> {t('legal.privacyPolicy90')}
						</p>
						<p className="legals__text">
							<span className="legals__text legals__subtitle">{t('legal.privacyPolicy91')}</span> {t('legal.privacyPolicy92')}
						</p>
						<p className="legals__text">
							<span className="legals__text legals__subtitle">{t('legal.privacyPolicy93')}</span> {t('legal.privacyPolicy94')}
						</p>
						<p className="legals__text">
							<span className="legals__text legals__subtitle">{t('legal.privacyPolicy95')}</span> {t('legal.privacyPolicy96')}
						</p>
					</div>
					<div className="legals__text-block">
						<p className="legals__text legals__subtitle">{t('legal.privacyPolicy97')}</p>
						<p className="legals__text">{t('legal.privacyPolicy98')}</p>
						<p className="legals__text">{t('legal.privacyPolicy99')}</p>
					</div>
					<div className="legals__text-block">
						<p className="legals__text legals__subtitle">{t('legal.privacyPolicy100')}</p>
						<p className="legals__text">{t('legal.privacyPolicy101')}</p>
						<p className="legals__text">{t('legal.privacyPolicy102')}</p>
						<p className="legals__text">{t('legal.privacyPolicy103')}</p>
					</div>
					<div className="legals__text-block">
						<p className="legals__text legals__subtitle">{t('legal.privacyPolicy104')}</p>
						<p className="legals__text">{t('legal.privacyPolicy105')}</p>
						<p className="legals__text">{t('legal.privacyPolicy106')}</p>
						<p className="legals__text">{t('legal.privacyPolicy107')}</p>
						<p className="legals__text">{t('legal.privacyPolicy108')}</p>
					</div>
					<div className="legals__text-block">
						<p className="legals__text legals__subtitle">{t('legal.privacyPolicy109')}</p>
					</div>
					<div className="legals__text-block">
						<p className="legals__text legals__subtitle">{t('legal.privacyPolicy110')}</p>
						<p className="legals__text">{t('legal.privacyPolicy111')}</p>
					</div>
					<div className="legals__text-block">
						<p className="legals__text legals__subtitle">{t('legal.privacyPolicy112')}</p>
						<p className="legals__text">{t('legal.privacyPolicy113')}</p>
					</div>
					<div className="legals__text-block">
						<p className="legals__text legals__subtitle">{t('legal.privacyPolicy114')}</p>
						<p className="legals__text">{t('legal.privacyPolicy115')}</p>
						<ul>
							<li>
								<p className="legals__text">{t('legal.privacyPolicy116')}</p>
							</li>
							<li>
								<p className="legals__text">{t('legal.privacyPolicy117')}</p>
							</li>
							<li>
								<p className="legals__text">{t('legal.privacyPolicy118')}</p>
							</li>
							<li>
								<p className="legals__text">{t('legal.privacyPolicy119')}</p>
							</li>
							<li>
								<p className="legals__text">{t('legal.privacyPolicy120')}</p>
							</li>
						</ul>
					</div>
					<div className="legals__text-block">
						<p className="legals__text legals__subtitle">{t('legal.privacyPolicy121')}</p>
						<p className="legals__text">{t('legal.privacyPolicy122')}</p>
					</div>
					<div className="legals__text-block">
						<p className="legals__text legals__subtitle">{t('legal.privacyPolicy123')}</p>
						<p className="legals__text">{t('legal.privacyPolicy124')}</p>
						<p className="legals__text">{t('legal.privacyPolicy125')}</p>
					</div>
					<div className="legals__text-block">
						<p className="legals__text legals__subtitle">{t('legal.privacyPolicy126')}</p>
						<p className="legals__text">{t('legal.privacyPolicy127')}</p>
						<p className="legals__text">{t('legal.privacyPolicy128')}</p>
					</div>
					<div className="legals__text-block">
						<p className="legals__text legals__subtitle">{t('legal.privacyPolicy129')}</p>
						<p className="legals__text">{t('legal.privacyPolicy130')}</p>
						<p className="legals__text">{t('legal.privacyPolicy131')}</p>
						<p className="legals__text">{t('legal.privacyPolicy132')}</p>
					</div>
					<div className="legals__text-block">
						<p className="legals__text legals__subtitle">{t('legal.privacyPolicy133')}</p>
						<p className="legals__text">{t('legal.privacyPolicy134')}</p>
						<ul>
							<li>
								<p className="legals__text">{t('legal.privacyPolicy135')}: info@sdl24.es</p>
							</li>
							<li>
								<p className="legals__text">
									{t('legal.privacyPolicy136')}:{' '}
									<a className="link" href="/contact-us">
										https://wondr.es/contact-us
									</a>
								</p>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<ContactSectionComponent />
		</div>
	);
};

export default PrivacyPolicy;